import { render, staticRenderFns } from "./looks.vue?vue&type=template&id=1a87688b&scoped=true"
import script from "./looks.vue?vue&type=script&lang=js"
export * from "./looks.vue?vue&type=script&lang=js"
import style0 from "./looks.vue?vue&type=style&index=0&id=1a87688b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a87688b",
  null
  
)

export default component.exports